/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useState } from 'react'

import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import Context from '../../context'
import getCroppedImg from '../../helpers/CropImage'

function LogoUpload({ cover = false }) {
  const {
    iconLogo,
    newLogo,
    setNewLogo,
    iconCover,
    newCover,
    setNewCover,
    crop,
    setCrop,
    cropCover,
    setCropCover,
    setLogoToUpload,
    setCoverToUpload
  } = useContext(Context)

  const [cropped, setCropped] = useState({ image: null, url: null })
  const [image, setImage] = useState(null)

  const onCropComplete = async newCroppArea => {
    if (image && newCroppArea.height && newCroppArea.width) {
      const img = await getCroppedImg(image, newCroppArea)
      if (cover) {
        newCover !== iconCover && setCropped({ image: img, url: window.URL.createObjectURL(img) })
      } else {
        newLogo !== iconLogo && setCropped({ image: img, url: window.URL.createObjectURL(img) })
      }
    }
  }

  useEffect(() => {
    if (cropped.image) {
      if (cover) setCoverToUpload(cropped.image)
      else setLogoToUpload(cropped.image)
    }
  }, [cropped])

  useEffect(() => {
    setCropped({ image: null, url: cover ? newCover : newLogo })
  }, [cover ? newCover : newLogo])

  const onImageLoaded = newImage => {
    setImage(newImage)
  }

  const handleLogo = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      const f = e.target.files[0]

      if (f) {
        if (cover) setCoverToUpload(f)
        else setLogoToUpload(f)
      }

      reader.onloadend = () => {
        if (cover) setNewCover(reader.result)
        else setNewLogo(reader.result)
      }

      reader.readAsDataURL(f)
    }
  }

  return (
    <div className="row" style={cover ? { marginTop: 160 } : {}}>
      <h5 className="col-12">{cover ? 'Capa' : 'Logo'}</h5>
      <div className="col-3 clube-crop">
        <div className="">
          <label htmlFor={cover ? 'coverImg' : 'logoImg'}>
            <img
              src={cropped.url || (cover ? newCover : newLogo)}
              alt=""
              className="rounded item-click partner-logo "
            />
          </label>
        </div>
        <input
          accept="image/*"
          hidden
          type="file"
          id={cover ? 'coverImg' : 'logoImg'}
          onChange={handleLogo}
        />
      </div>

      {cover && newCover !== iconCover && (
        <div className="col-8 clube-crop">
          <div className="crop-container">
            <ReactCrop
              src={newCover}
              crop={cropCover}
              onImageLoaded={onImageLoaded}
              onComplete={onCropComplete}
              onChange={newCrop => setCropCover(newCrop)}
            />
          </div>
        </div>
      )}
      {!cover && newLogo !== iconLogo && (
        <div className="col-8 clube-crop">
          <div className="crop-container">
            <ReactCrop
              src={newLogo}
              crop={crop}
              onImageLoaded={onImageLoaded}
              onComplete={onCropComplete}
              onChange={newCrop => setCrop(newCrop)}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default LogoUpload
